<template>
  <div class="a4Parent">
    <div class="a4Horizontal-ctn">
      <div id="page-header" :style="{ zoom: zoomRatio }">
        <div class="info-one" :style="{ zoom: zoomRatio }">
          <img src="@/assets/pancares-logo.svg" alt="pancares logo" />
          <div class="pageHeader-titleCtn">
            <div class="pageHeader-titleCtn_title">
              {{ isPump ? $t('Pump Report') : $t('BG Report') }}
            </div>
            <div class="pageHeader-titleCtn_tip">
              {{ $t('Fingerstick, from BG meter, AiDEX, CGMs PDA and Pump PDA') }}
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="info-two" :style="{ zoom: zoomRatio }">
          <div><div class="info-two_label">{{ $t(`Patient's Name`) }}：</div><div class="info-two_content">{{ patientName }}</div></div>
          <div><div class="info-two_label">{{ $t('Assessment Time') }}：</div><div class="info-two_content">{{ assessmentTime }}</div></div>
          <div>          
            <div class="info-two_label" v-if="!isPump && bgmSnList.length">{{ $t('BGM SN') }}：</div><div class="info-two_content">{{ bgmSnList.join(',') || baseInfo.device }}</div>
            <div class="info-two_label">{{ $t('PDA SN') }}：</div><div class="info-two_content">{{ pdaSnList.join(',') || baseInfo.device2 }}</div>
            <div class="info-two_label" style="margin-left: 3em;" v-if="isPump">{{ $t('PUMP SN') }}：</div><div class="info-two_content">{{ pumpSnList.join(',') || baseInfo.device3 }}</div>
          </div>
          <div v-if="isPump && false" style="color: #DA0A0A;"><div class="info-two_label">{{ $t('Notice') }}：</div><div class="info-two_content">{{ $t('Difference in time over 1 hour between uploading and recording') }}</div></div>
        </div> 
      </div>
      <div id="page-footer" :style="{ zoom: zoomRatio }"></div>
      <div class="page-ctn" :style="pageCtnStyle" :class="{ noFlexGrow, noTitle, isGrid }">
        <div class="tips" :style="{ zoom: zoomRatio, marginTop: Math.floor(zoomRatio * 20) + 'px' }">
          <div class="border" v-if="!noTitle"></div>
          <div class="label" v-if="!noTitle">
            <span>{{ $t(title) }}</span>
            <div class="assessmentTime-ctn">
              <span class="assessmentTime-label">
                {{ $t('Assessment Time') }}:
              </span>
              <span class="assessmentTime-content" v-if="atime">
                {{ atime | formatTime('YYYY/MM/DD') }}
              </span>
              <span class="assessmentTime-content" v-else>
                {{ assessmentTime }}
              </span>
            </div>
          </div>
          <!-- <div class="assessmentTime-ctn"> -->
          <!--   <div class="assessmentTime-label"> -->
          <!--     {{ $t('Assessment Time') }}: -->
          <!--   </div> -->
          <!--   <div class="assessmentTime-content"> -->
          <!--     {{ assessmentTime }} -->
          <!--   </div> -->
          <!-- </div> -->
        </div>
        <div class="page-ctn_row page-ctn_row--first" :style="{ marginTop: firstRowNoMarginTop ? 0 : Math.floor(zoomRatio * 52) + 'px' }">
          <slot name="firstRow"></slot>        
        </div>
        <div class="page-ctn_row page-ctn_row--second" :style="{ marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
          <slot name="secondRow"></slot>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import reDrawTrigger from '@mx/reDrawTrigger'

export default {
  name: 'CA4Horizontal',
  mixins: [reDrawTrigger],
  props: {
    pdaSnList: {
      type: [Array],
      default: () => []
    },
    pumpSnList: {
      type: [Array],
      default: () => []
    },
    bgmSnList: {
      type: [Array],
      default: () => []
    },
    title: {
      type: String,
      default: 'whatPage'
    },
    atime: { // assessment time是否改成使用这个
      type: String,
      default: ''
    },
    noFlexGrow: {
      type: Boolean,
      default: false
    },
    noPad: {
      type: Boolean,
      default: false
    },
    lessPad: {
      type: Boolean,
      default: false
    },
    isPump: {
      type: Boolean,
      default: false
    },
    isGrid: { // 通过flex模拟grid.firstRow和secondRow分开
      type: Boolean,
      default: false
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    firstRowNoMarginTop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      baseInfo: {}
    }
  },
  mounted() {
    this.baseInfo = this.$route.query
  },
  computed: {
    pageCtnStyle() {
      const { zoomRatio, noPad, lessPad } = this
      const rst = { padding: `0 ${Math.floor(32 * zoomRatio)}px ${Math.floor(20 * zoomRatio)}px ${Math.floor(32 * zoomRatio)}px` }

      if (noPad) {
        rst.padding = '0 0 0 0'
      }
      if (lessPad) {
        const vp = 8
        rst.padding = `0 ${Math.floor(vp * zoomRatio)}px ${Math.floor(20 * zoomRatio)}px ${Math.floor(vp * zoomRatio)}px`
      }
      return rst
    }
  },
  methods: {
    refreshTriggered() {
      // console.error(`rrefresh进行更新`)
      // 语言切换
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';
$a4HL: 20.88cm; /*比21cm小一点点，是因为有些打印机上高度不是严格的21cm;然后此时设置成了21cm，那么会导致渲染超过一页。从而有一部分显示不出来*/
$a4H: 20.8cm; /* 最后实际是否发现，21cm小一点点的话，有些时候会打印出空白页, 所以就稍微大一点.然后将几个比较临界的页面，增加一个largerA4的class */
.a4Horizontal-ctn {
    /* page-break-after: always; */
    /* break-after: page; */
    page-break-before: always;
    break-before: page;
    position: relative;
    /* width: $sizeWidth; */
    /* height: $sizeHeight + $sizeHeightHeader; */
    /* padding: 0 0;     */    
    background-color: white;
    @include flexColumn(flex-start, flex-start);
    @include bBox;
    width: 29.7cm;
    /* height: 21cm; */
    height: $a4HL; /*比21cm小一点点，是因为有些打印机上高度不是严格的21cm;然后此时设置成了21cm，那么会导致渲染超过一页。从而有一部分显示不出来*/
    height: $a4H; /* 最后实际是否发现，21cm小一点点的话，有些时候会打印出空白页, 所以就稍微大一点.然后将几个比较临界的页面，增加一个largerA4的class */
    &.lastA4Page {
        height: $a4H;/*比21cm小一点点，是因为有些打印机上高度不是严格的21cm;然后此时设置成了21cm，那么会导致渲染超过一页。从而有一部分显示不出来*/
        /* background: red; */
    }
    &.largerA4 {
        height: $a4HL; /*比21cm小一点点，是因为有些打印机上高度不是严格的21cm;然后此时设置成了21cm，那么会导致渲染超过一页。从而有一部分显示不出来*/
    }
    margin: auto auto;
    margin-top: 20px;
    overflow: hidden;
    
    .page-ctn {
        width: 100%;
        @include bBox;
        @include flexColumn(space-between, flex-start);
        &.noFlexGrow {
            @include flexColumn(flex-start, flex-start);
        }
        &.isGrid {
            .page-ctn_row--first, .page-ctn_row--second {
                flex-grow: 1;
                flex-shrink: 1;
            }
        }
        flex-grow: 1;
        padding: 0 32px 20px 32px;
        > div {
            justify-content: space-between;
        }
        .tips {
            @include bBox;
            $th: 40px;
            page-break-inside: avoid;
            font-size: 18px;
            font-weight: 500;
            margin-top: 20px;
            line-height: $th;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            position: relative;
            /* left: -22px; */
            .border {
                width: 20px;
                @include heightMiddle($th);
                background: $colorA4PageTitleGreenBg;
                border-radius: 12px 4px 4px 12px;
                margin-right: 10px;
                background-color: $colorA4PageTitleGreenBg;
            }
            .label {
                color: white;
                background-color: $colorA4PageTitleGreenBg;
                border-radius: 5px;
                padding: 0 20px;
                @include heightMiddle($th);
                > * {
                    vertical-align: top;
                }
            }
            .assessmentTime-ctn {
                display: inline-block;
                margin-left: 30px;
                @include heightMiddle($th);
                border-radius: 8px;
                font-size: $sizeTitle;
                /* border: 1px solid $colorGluMesurementInnerBorder; */
                padding: 8px 10px;
                @include bBox;
                /* font-weight: bold; */
                
                .assessmentTime-label, .assessmentTime-content {
                    display: inline-block;
                    line-height: initial;
                    vertical-align: top;
                    font-weight: initial;
                }
                .assessmentTime-label {
                    margin-right: 0.5em;
                }
            }

            > div {
                box-sizing: border-box;
            }
        }
        &.noTitle {
            .tips .assessmentTime-ctn {
                margin-left: 0;
            }
        }
        
        .page-ctn_row {
            @include flexRow(space-between, flex-start);
            @include bBox;
            width: 100%;
        }
        
        .page-ctn_row--first {
            /* background-color: blue; */
            /* justify-content: flex-start; */
            justify-content: space-between;
            /* flex-grow: 1; */
        }
        
        .page-ctn_row--second {
            justify-content: flex-start;
        }
    }
    
    #page-header {
        width: 100%;
        height: $sizeHeightHeader;
        height: calc($sizeHeightHeader--num / $sizeHeight--num) * 21cm;
        top: 0;
        border-bottom: 1px dashed $colorA4PageHeaderBorder;
        /* display: none; */
        @include bBox;
        @include flexRow(flex-start, center);
        .info-one > img {
            display: block;
            width: 161px;
            height: 57px;
            margin-left: 40px;
            margin-right: 1em;
        }
        .info-one, .info-two {
            /* flex-grow: 1; */
        }
        
        .info-one {
            width: 49.8%;
            @include flexRow(flex-start, center);
            .pageHeader-titleCtn {
                color: #4294bf;
                font-size: 24px;
                flex-grow: 1;
                @include flexColumn(space-between, flex-start);
                color: $colorA4PageTitleGreenBg;
                
                .pageHeader-titleCtn_title {
                    font-size: 34px;
                    font-weight: bold;
                    font-weight: bolder;
                    font-weight: 900;
                }
                .pageHeader-titleCtn_tip {
                    font-size: 18px;
                }
            }
            .name-panel {
                font-size: 12px;
                display: inline-flex;
                justify-content: flex-start;
            }
        }
        .info-two {
            @include flexColumn(space-around, flex-start);
            font-size: 12px;
            color: rgba(0, 0, 0, 0.76);
            font-size: 18px;
            font-weight: 500;
            .info-two_label, .info-two_content {
                display: inline-block;            
            }
            > div {
                margin-top: 8px;
            }
        }
        .divider {
            height: 100%;
            width: 2px;
            margin-right: 30px;
            border-left: 1px dashed $colorA4PageHeaderBorder;
        }
    }
    #page-footer {
        position: absolute;
        height: 0;
        bottom: 0;
        width: 100%;
        /* display: none; */
    }
}
.a4-breaker {
    visibility: hidden;
    page-break-after: always;
    break-after: page;
}
.a4Parent {
    /* page-break-after: always; */
    /* break-after: page;  */   
    page-break-before: always;
    break-before: page;
}

@media print {
    .a4Horizontal-ctn {
        margin-top: 0;
        margin: auto auto;
        /* page-break-after: always; */
        /* break-after: page; */
        page-break-before: always;
        break-before: page;
        
        /* border-bottom: 1px solid red; */
        /* width: 29.7cm; */
        /* height: 21cm; */
        /* margin: auto auto; */
        /* border: 1px #D3D3D3 solid; */
        /* border-radius: 5px; */
        /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    }
    .a4-breaker {
        visibility: hidden;
        page-break-after: always;
        break-after: page;   
    }
    .a4Parent {
        /* page-break-after: always; */
        /* break-after: page;     */
        page-break-before: always;
        break-before: page;
    }
}
</style>
